<!--
  ~ Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<div class="bci-content-container">
  <ng-content select="bci-sidebar"></ng-content>
  <ng-content> </ng-content>

  <div class="bci-content-container-main"></div>
</div>
